import { getusertiporgs, getcompetencymanagelist } from '@/port/schoolInstrument/appConfig.js'
import { getapiorganizationlist } from '@/port/clientSide/multipleChoice.js'
import { getcustomdesk, getwebsiteapproval, getapprovaldashboard } from '@/port/pages/webSite.js'
import { outhreflogin, getaccesstoken } from '@/port/pages/login'
import { setParamsList } from '@/util/customData.js'
import { cloneDeep } from 'lodash'
import { defineAsyncComponent } from 'vue'
import qs from 'qs'
import internalNetwork from './internalNetwork'
export default {
  data() {
    return {
      openSpaceChoose: false,
      curSpaceList: [],
      curConfirmSpace: {},
      skey: this.$route.params.skey || this.$route.query.skey,
      internalNetworkType: 'shutDown',
      openInternalNetwork: false
    }
  },
  components: {
    spaceChoose: defineAsyncComponent(() => import('@/components/common/chooseSpace.vue')),
    internalNetwork
  },
  methods: {
    async goCustomDesk(item, opt) {
      const user = localStorage.getItem('user')
      const customData = this.customDeskId ? this.$store.state.doorCustomDataObj[this.customDeskId] :this.$store.state.doorCustomData
      const { chooseOpen, customSize, type, customInfo, navType = 'col', dialogInfo, info } = opt
      if (!item.pcUrl) return
      //- 自定义页面
      const parse = qs.parse(item.pcUrl.split('?')[1])
      console.log(parse, 'parse')
      const __id = parse.customDeskId
      let isOpen = false
      const skey = this.skey
      if (skey && !user) {
        const __par = { customDeskId: __id, skey, sence: 2, type: 1 }
        if (this.spaceid) {
          __par.spaceid = this.spaceid
        }
        const res = await getcustomdesk(__par).catch(err => {
          this.$message.error('接口错误')
          console.log(err);
        })
        if (res.code === 0) {
          const data = res.data.openfunction
          if (data && data.status === 1) {
            isOpen = true
          } else {
            if (navType === 'nav') {
              this.$emit('to-login', customInfo)
            } else {
              this.$emit('open-login', info, this.dataInfo.i)
            }
            return
          }
        } else {
          this.$message.error(res.msg)
          return
        }
      }
      // 页面入参
      let paramsList = cloneDeep(item.paramsList || [] )
      if (paramsList.length === 0) paramsList = info && info.paramsList ? info.paramsList : []
      const paramsLists = setParamsList(paramsList, customData)
      if (this.$route.path === '/customInstrument') {
        //- 相同域名
        if (chooseOpen) {
          const _query = { customDeskId: __id, ...parse }
          if (paramsLists.length > 0) _query.paramsList = JSON.stringify(paramsLists)
          if (this.spaceid) _query.spaceid = this.spaceid
          else if (this.upaceid) _query.upaceid = this.upaceid
          if (skey && isOpen) _query.skey = skey
          if (chooseOpen === 'old') {
            window.location.replace(`${item.pcUrl}&${qs.stringify(_query)}`)
          } else if (chooseOpen === 'new') {
            _query.showNav = false
            this.$openNewPage(item.pcUrl, _query)
          } else if (chooseOpen === 'dialog' || chooseOpen === 'rightdia') {
            this.dialogInfo.dialogName = item.params
            this.dialogInfo.openType = chooseOpen
            this.dialogInfo.customSize = customSize
            if (item.pcUrl && item.pcUrl.includes('customDeskId')) {
              item.pcUrl = item.pcUrl.split('?')[0]
            }
            if (navType === 'col') {
              this.handleDialogOpen(customInfo, `${item.pcUrl}?${qs.stringify(_query)}`)
            } else {
              this.handleDialog(`${item.pcUrl}?${qs.stringify(_query)}`, dialogInfo, item.params)
            }
          }
        } else {
          window.location.replace(item.pcUrl)
        }
      } else {
        if (!item.pcUrl || item.pcUrl === '') return
        const query = { showNav: true, name: item.params, customDeskId: __id }
        if (paramsLists.length > 0) query.paramsList = JSON.stringify(paramsLists)
        this.spaceid ? query.spaceid = this.spaceid : ''
        this.upaceid ? query.upaceid = this.upaceid : ''
        if (skey && isOpen) query.skey = skey
        if (type === 'platformCustom' && query.spaceid) delete query.spaceid
        else if (type === 'platformCustom' && query.upaceid) delete query.upaceid
        console.log(chooseOpen,'chooseOpenchooseOpen')
        if (chooseOpen) {
          if (chooseOpen === 'old') {
            this.$router.push({
              path: item.pcUrl,
              query
            });
          } else if (chooseOpen === 'new') {
            query.showNav = false
            this.$openNewPage(item.pcUrl, query)
          } else if (chooseOpen === 'dialog' || chooseOpen === 'rightdia') {
            this.dialogInfo.dialogName = item.params
            this.dialogInfo.openType = chooseOpen
            this.dialogInfo.customSize = customSize
            query.showNav = false
            console.log(query, 'queryquery', navType)
            // 注释掉这个是因为第二次打开的时候这个customDeskId会被裁切掉，导致无法打开
            // if (item.pcUrl && item.pcUrl.includes('customDeskId')) {
            //   item.pcUrl = item.pcUrl.split('?')[0]
            // }
            if (navType === 'col') {
              this.handleDialogOpen(customInfo, `${item.pcUrl}?${qs.stringify(query)}`)
            } else {
              const route = this.$router.resolve({
                path: item.pcUrl,
                query
              })
              this.handleDialog(route.href, dialogInfo, item.params)
            }
          }
        } else {
          this.$router.push({
            path: item.pcUrl,
            query
          })
        }
      }
    },
    customOpenAbility(val, type) {
      const { open, popUps } = val.insideInfo
      const { w: explainTextWidth, h: explainTextHeight, customSize, diaSize } = popUps
      const obj = {
        3: 'new',
        2: 'dialog',
        4: 'olg',
        5: 'rightdia'
      }
      this.openAbility(val.abilityInfo, obj[open], { explainTextWidth, explainTextHeight, customSize, diaSize }, type)
    },
    async getToSpaceId(info = []) {
      if (!info) return
      let types
      if (Object.prototype.toString.call(info) === '[object Array]') {
        types = info.map(item => {
          return item.spaceId
        }).join(',')
      } else if (Object.prototype.toString.call(info) === '[object Object]') {
        types = info.spaceId
      }
      const { data, code, msg } = await getusertiporgs({
        types
      })
      if (code === 0) {
        const space = data.map(item => {
          return {
            name: item.name,
            spaceId: item.organizationId
          }
        })
        this.curSpaceList = data
        return space
      } else {
        this.$message.error(msg)
      }
    },
    goSpace(item) {
      const { chooseOpen, value, dialogInfo, isApp, name } = this.curConfirmSpace
      const par = {
        spaceid: item.spaceId
      }
      if (isApp === true) {
        // 应用栏目和菜单栏目
        this.handleInsidePage(par, '/space/index', chooseOpen, name, dialogInfo)
      } else if (isApp === undefined) {
        // 图片组件和分组栏目
        this.handleInsidePage(par, '/space/index', chooseOpen, value, dialogInfo)
      } else if (isApp === false) {
        // 顶部导航栏
        this.handleNavInside(par, '/space/index', chooseOpen, dialogInfo, '')
      }
    },
    async openAbility(info, opentype, applyDiaInfo, type) {
      if (!opentype && !info) return
      const { url, item } = await this.nextProcess(info)
      if (!url && !item) {
        this.$message.error('没有跳转地址')
        return
      }
      let isHttp = false
      let textInfo = localStorage.getItem('currentTranscription');
      if (textInfo) {
        textInfo = JSON.parse(textInfo);
        textInfo.isAi = true
        localStorage.setItem('currentTranscription', JSON.stringify(textInfo))
      }
      if (url.includes('http')) {
        isHttp = true
      }
      this.dialogInfo.dialogName = info.name
      this.dialogInfo.openType = opentype
      // 选择的知识库
      if(info.valueKnowledge && info.valueKnowledge.length > 0) {
        this.dialogInfo.valueKnowledge = info.valueKnowledge
      }
      // 样式配置
      if(info.agentConfig && Object.keys(info.agentConfig).length !== 0) {
        this.dialogInfo.agentConfig = info.agentConfig
      } else {
        this.dialogInfo.agentConfig = {"style":{"style":1,"text1":"嗨，我是你的AI助理，右侧填写表单，智能体即刻就位。","text2":"Hi~我是小助理，很高兴为您服务。","avatarId":"enterprise-0","searchVal":"我是AI助理，需要什么帮忙？","fullBodyImage":"","halfBodyImage":""}}
      }
      // 预设参数&常用问题设置
      if(info.paramQuesConfig) {
        this.dialogInfo.paramQuesConfig = info.paramQuesConfig
      }
      // 联网搜索
      if(info.onlineSearch) {
        this.dialogInfo.onlineSearch = info.onlineSearch
      }
      // 解析方式、ocr识别等
      if(info.otherSet) {
        this.dialogInfo.otherSet = info.otherSet
      }
      // 当前aiId
      if(info.chatId) {
        this.dialogInfo.chatId = info.chatId
      }
      if (opentype === 'new') {
        localStorage.setItem('aichatNew', JSON.stringify(this.dialogInfo));
        window.open(url + (url.includes('?') ? '&' : '?') + 'storage=true');
      } else if (opentype === 'old') {
        if (isHttp) {
          const query = { url }
          this.$router.push({
            path: "/bearing",
            query
          });
        } else {
          this.$router.push({
            path: url
          })
        }
      } else if (opentype === 'dialog' || opentype === 'rightdia') {        
        if (type === 'nav') {
          // 导航的方法特殊处理
          this.handleDialog(url, applyDiaInfo, info.name)
        } else {
          this.handleDialogOpen(applyDiaInfo, url)
        }
      }
    },
    async nextProcess(info) {
      console.log('info==',info)
      let { id, aiList, valueKnowledge, historyId, isHistory } = info
      let url = ''
      const par = {
        curpage: 0,
        pagesize: 0,
        id
      }
      if (this.$route.query.upaceid || (this.$route.query.upace && localStorage.getItem('upaceid'))) {
        par.upaceid = this.$route.query.upaceid || localStorage.getItem('upaceid')
      }
      const { data, code, msg } = await getcompetencymanagelist(par)
      if (code === 0) {
        const item = data[0]
        if (!aiList) aiList = ['deepseek-chat']
        if (item.type === 1) {
          console.log('valueKnowledge==',valueKnowledge)
          let chatUrl = `/aichatNew?check=${JSON.stringify(aiList)}&isHistory=${isHistory}&historyId=${historyId}`
          if (valueKnowledge && valueKnowledge.length > 0) {
            chatUrl += `&valueKnowledge=${JSON.stringify(valueKnowledge)}`
          }
          const obj = {
            任务协同工具: '/mission/myFillIn',
            组织协同工具: `${this.$url}/tripartiteLogin?isZt=${this.$zturl}&redirect=/diagrams/memberManagements`,
            区块链存储: `${this.$url}/tripartiteLogin?isZt=${this.$zturl}&redirect=/blockchain`,
            统一认证能力: `${this.$url}/tripartiteLogin?isZt=${this.$zturl}&redirect=/UA`,
            组织架构赋能: `${this.$url}/tripartiteLogin?isZt=${this.$zturl}&redirect=/OSE`,
            人工智能查询: chatUrl,
            即时通讯工具: 'https://kdocs.cn/l/csDFZ8Vgs7Dk',
            网盘工具: 'https://kdocs.cn/l/cu8aGKjXMUJF',
            知识库: '/knowledgeBase',
            人脸识别: 'https://kdocs.cn/l/cdTIH5RBHbPE',
            电子签章: 'https://kdocs.cn/l/clfW78eHgvlr',
            专利查询系统: `${this.$url}/tripartiteLogin?isZt=${this.$zturl}&redirect=/patentQueryAb`,
            专利评价系统: `${this.$url}/tripartiteLogin?isZt=${this.$zturl}&redirect=/patentEvaluationAb`,
            商标查询系统: `${this.$url}/tripartiteLogin?isZt=${this.$zturl}&redirect=/brandQueryAb`,
            标识编码查询系统: `${this.$url}/tripartiteLogin?isZt=${this.$zturl}&redirect=/idcodeQuery`,
          }
          url = obj[item.name]
        } else if (item.type === 2) {
          url = item.manageAddress
        }
        return {
          url,
          item
        }
      } else {
        this.$message.error(msg)
      }
    },
    async getWebsiteUserInfo(iId, isReturn = false, isCatch = true) {
      if (iId !== 11 && !isReturn) return
      const skey = this.$route.params.skey || this.$route.query.skey
      if (!skey) return
      let accesstoken = ''
      for (let i = 0; i < 6; i++) {
        accesstoken += Math.floor(Math.random() * 10);
      }
      const { data, code } = await outhreflogin({ skey, accesstoken })
      if (code === 0) {
        let date = {
          schoolId: data.listschool[0].schoolId,
          openId: data.userId,
          accesstoken: accesstoken
        }
        const res = await getaccesstoken(date)
        if (res.code === 0) {
          const user = res.data
          if (isCatch) {
            localStorage.setItem('visitorUser', JSON.stringify(user))
          }
          if (isReturn) return user.accesstoken
        }
      }
    },
    async getAppInfo(id, type = 1, spaceid) {
      let fn = getwebsiteapproval
      let _par = {
        skey: this.skey,
      }
      if (type === 5) {
        fn = getapprovaldashboard
        _par.approvalDashboardId = id
      } else {
        _par.approvalId = id
      }
      if (spaceid) {
        _par.spaceid = spaceid
      }
      
      if (this.spaceid) {
        _par.spaceid = this.spaceid
      }

      const res = await fn(_par)
      if (res.code === 0) {
        if (res.data.status === 0) {
          return false
        }
        return res.data.openfunction
      }
    },
    async openSystemManagement(opt) {
      const { info, chooseOpen, dialogInfo, type } = opt
      const res = await getapiorganizationlist({ curpage: 1, pagesize: 1, pid: 0 })
      if (res.code !== 0) {
        this.$message.error(res.msg)
        return
      }
      let path = info.path
      if (info.id === 'userLog') {
        path += `?userId=true`
      }
      if (chooseOpen === 'old') {
        window.location.replace(path)
      } else if (chooseOpen === 'new') {
        const route = this.$router.resolve({
          path
        })
        window.open(route.href, '_blank')
      } else if (chooseOpen === 'dialog' || chooseOpen === 'rightdia') {
        this.dialogInfo.dialogName = info.name
        this.dialogInfo.openType = chooseOpen
        if (type === 'nav') {
          // 导航的方法特殊处理
          this.handleDialog(path, dialogInfo, info.name)
        } else {
          this.handleDialogOpen(dialogInfo, path)
        }
      }
    },
  }
}